import React, { createContext, useContext, useState } from 'react';
import translations from './locales';

const I18nContext = createContext();

const supportedLanguages = ['en', 'sv'];
const defaultLanguage = 'en';

export const I18nProvider = ({ children }) => {
  const localLangIsSupported = supportedLanguages.includes(
    localStorage.getItem('language'),
  );

  const [language, setLanguage] = useState(
    localLangIsSupported ? localStorage.getItem('language') : defaultLanguage,
  );
  const [weekstart, setWeekstart] = useState(
    localStorage.getItem('weekstart') || 'mon',
  );

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const changeWeekstart = (start) => {
    setWeekstart(start);
    localStorage.setItem('weekstart', start);
  };

  return (
    <I18nContext.Provider
      value={{
        t: translations[language],
        weekstart,
        changeLanguage,
        changeWeekstart,
      }}
    >
      {children}
    </I18nContext.Provider>
  );
};

export const useTranslation = () => {
  return useContext(I18nContext);
};
